import API from '../api/api'
import { exportPages } from './pages'
import {_exportDownloadLinkDecorator} from '../helper'

const SYNC_BLOGS_PENDING = 'SYNC_BLOGS_PENDING'
const SYNC_BLOGS_PROGRESS = 'SYNC_BLOGS_PROGRESS'
const SYNC_BLOGS_RESPONSE = 'SYNC_BLOGS_RESPONSE'
const SYNC_BLOG_PENDING = 'SYNC_BLOG_PENDING'
const SYNC_BLOG_RESPONSE = 'SYNC_BLOG_RESPONSE'
const SAVE_BLOGS_PENDING = 'SAVE_BLOGS_PENDING'
const SAVE_BLOGS_PROGRESS = 'SAVE_BLOGS_PROGRESS'
const SAVE_BLOGS_RESPONSE = 'SAVE_BLOGS_RESPONSE'
const SAVE_BLOGS_ABORTED = 'SAVE_BLOGS_ABORTED'
const SYNC_BLOG_METAFIELDS_PENDING = 'SYNC_BLOG_METAFIELDS_PENDING'
const SYNC_BLOG_METAFIELDS_PROGRESS = 'SYNC_BLOG_METAFIELDS_PROGRESS'
const SYNC_BLOG_METAFIELDS_RESPONSE = 'SYNC_BLOG_METAFIELDS_RESPONSE'
const SYNC_BLOG_METAFIELDS_ABORTED = 'SYNC_BLOG_METAFIELDS_ABORTED'
const CREATE_BLOG_CUSTOM_CONTENTS_PENDING = 'CREATE_BLOG_CUSTOM_CONTENTS_PENDING'
const CREATE_BLOG_CUSTOM_CONTENTS_PROGRESS = 'CREATE_BLOG_CUSTOM_CONTENTS_PROGRESS'
const CREATE_BLOG_CUSTOM_CONTENTS_RESPONSE = 'CREATE_BLOG_CUSTOM_CONTENTS_RESPONSE'
const DELETE_BLOG_CUSTOM_CONTENT_PENDING = 'DELETE_BLOG_CUSTOM_CONTENT_PENDING'
const DELETE_BLOG_CUSTOM_CONTENT_PROGRESS = 'DELETE_BLOG_CUSTOM_CONTENT_PROGRESS'
const DELETE_BLOG_CUSTOM_CONTENT_RESPONSE = 'DELETE_BLOG_CUSTOM_CONTENT_RESPONSE'
const EXPORT_BLOGS_PENDING = 'EXPORT_BLOGS_PENDING'
const EXPORT_BLOGS_PROGRESS = 'EXPORT_BLOGS_PROGRESS'
const EXPORT_BLOGS_RESPONSE = 'EXPORT_BLOGS_RESPONSE'
const IMPORT_BLOGS_PENDING = 'IMPORT_BLOGS_PENDING'
const IMPORT_BLOGS_PROGRESS = 'IMPORT_BLOGS_PROGRESS'
const IMPORT_BLOGS_RESPONSE = 'IMPORT_BLOGS_RESPONSE'
const RESET_ERRORS = 'RESET_ERRORS'
const CLEAR_EXPORT_URLS = 'CLEAR_EXPORT_URLS'

const initialState = {
  sync_blogs_pending: true,
  sync_blog_pending: false,
  sync_blog_metafields_pending: false,
  save_blogs_pending: false,
  create_blog_custom_contents_pending: false,
  delete_blog_custom_content_pending: false,
  export_blogs_pending: false,
  export_po_download_url: null,
  export_csv_download_url: null,
  import_blogs_pending: false,
  imported_entries: 0,
  progress: 0,
  error: false,
  blogs: [],
}

function validateBlog(data, origin) {
  if (typeof data.general_errors !== 'undefined' && typeof data.general_errors.errors !== 'undefined') {
    data.general_errors.errors.forEach(item => {
      switch(item.object_key) {
        case 'handle' :
          //data.target.handle = origin.target.handle;
          break;
      }
    })
  }
  return data;
}


// REDUCER
export default (state = initialState, action) => {
  switch(action.type) {
    case RESET_ERRORS: {
      return {
        ...state,
        error: false,
      }
    }

    case SYNC_BLOGS_PENDING: {
      return {
        ...state,
        progress: 0,
        sync_blogs_pending: true,
        export_po_download_url: null,
        export_csv_download_url: null,
        error: false,
      }
    }
    case SYNC_BLOGS_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    case SYNC_BLOGS_RESPONSE: {
      if(action.response.success === true) {
        return {
          ...state,
          sync_blogs_pending: false,
          error: false,
          blogs: action.response.blogs
        }
      } else {
        return {
          ...state,
          sync_blogs_pending: false,
          error: {
            message: action.response,
            action: action.action,
            level: 0,
          },
        }
      }
    }

    case SYNC_BLOG_PENDING: {
      return {
        ...state,
        progress: 0,
        sync_blog_pending: true,
        error: false,
      }
    }
    case SYNC_BLOG_RESPONSE: {
      if(action.response.success === true) {
        let newBlogs = state.blogs.slice()
        let blogToUpdate = newBlogs.find(x => x.id == action.response.blog.id)
        
        blogToUpdate.synchronized = true;

        blogToUpdate.progress = action.response.blog.progress

        blogToUpdate.source.title = action.response.blog.source.title
        blogToUpdate.source.handle = action.response.blog.source.handle
        blogToUpdate.source.page_title = action.response.blog.source.page_title
        blogToUpdate.source.page_description = action.response.blog.source.page_description
        
        blogToUpdate.target.title = action.response.blog.target.title
        blogToUpdate.target.handle = action.response.blog.target.handle
        blogToUpdate.target.page_title = action.response.blog.target.page_title
        blogToUpdate.target.page_description = action.response.blog.target.page_description

        blogToUpdate.custom_contents = action.response.blog.custom_contents.slice()
        blogToUpdate.customSeo = action.response.blog.custom_seo
        
        return {
          ...state,
          blogs: newBlogs,
          sync_blog_pending: false,
          error: false,
        }
      } else {
        return {
          ...state,
          sync_blog_pending: false,
          error: {
            message: action.response,
            action: action.action,
            level: 1,
          },
        }
      }
    }

    case SAVE_BLOGS_PENDING: {
      return {
        ...state,
        progress: 0,
        save_blogs_pending: true,
        error: false,
      }
    }
    case SAVE_BLOGS_PROGRESS: {
      return {
        ...state,
        progress: action.progress
      }
    }
    // A save dropped because the merchant left the language never answers, and nothing refires
    // it the way a switch refires the sync - so the flag it set is cleared here. Not an error:
    // the merchant asked for the interruption.
    case SAVE_BLOGS_ABORTED: {
      return {
        ...state,
        progress: 0,
        save_blogs_pending: false,
        error: false,
      }
    }
    case SAVE_BLOGS_RESPONSE: {
      // The response echoes what was written for the language the save was issued for. The
      // abort races a response already on the wire, so it can still land after the merchant
      // selected another language - applying it then is what puts one language's text under another.
      if(action.stale === true) {
        return {
          ...state,
          save_blogs_pending: false,
          error: false,
        }
      }

      let error = false;
      let newBlogs = state.blogs.slice();
      action.response.forEach((response, i) => {
        if(response.success !== true) {
          error = {
            message: action.response,
            action: action.action,
          };
        } else {
          let newBlog = newBlogs.find(x => x.id == response.blog.id)
          let blog = validateBlog(response.blog,newBlog)
          newBlog.progress = blog.progress
          // commented out so source is not overwritten if backend returns insufficient data
          // newBlog.source = {...blog.source}
          newBlog.target = {...blog.target}
          newBlog.metafields = blog.metafields.slice()
          newBlog.custom_contents = blog.custom_contents.slice()
          newBlog.errors = blog.general_errors.errors
        }
      })
      return {
        ...state,
        blogs: newBlogs,
        save_blogs_pending: false,
        error: error
      }
    }

    case SYNC_BLOG_METAFIELDS_PENDING: {
      return {
        ...state,
        progress: 0,
        sync_blog_metafields_pending: true,
        error: false,
      }
    }
    case SYNC_BLOG_METAFIELDS_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    case SYNC_BLOG_METAFIELDS_ABORTED: {
      return {
        ...state,
        sync_blog_metafields_pending: false,
        error: false,
      }
    }
    case SYNC_BLOG_METAFIELDS_RESPONSE: {
      // A row sync answers for the language it was issued in; landing after a switch it would
      // stamp that language's fields on the row now on screen and mark it as synced.
      if(action.stale === true) {
        return {
          ...state,
          sync_blog_metafields_pending: false,
        }
      }
      if(action.response.success === true) {
        let newBlogs = state.blogs.slice()
        let blogToUpdate = newBlogs.find(x => x.id == action.response.blog_id)
        if(!blogToUpdate) {
          return { ...state, sync_blog_metafields_pending: false }
        }
        
        blogToUpdate.metafields_synchronized = true;
        blogToUpdate.metafields = action.response.metafields.slice()

        return {
          ...state,
          sync_blog_metafields_pending: false,
          blogs: newBlogs,
          error: false
        }
      } else {
        return {
          ...state,
          sync_blog_metafields_pending: false,
          error: {
            message: action.response,
            action: action.action,
            level: 2,
          },
        }
      }
    }
    case CREATE_BLOG_CUSTOM_CONTENTS_PENDING: {
      return {
        ...state,
        create_blog_custom_contents_pending: true,
        error: false,
      }
    }
    case CREATE_BLOG_CUSTOM_CONTENTS_PROGRESS: {
      return {
        ...state,
        progress: action.progress
      }
    }
    case CREATE_BLOG_CUSTOM_CONTENTS_RESPONSE: {
      let newBlogs = state.blogs.slice()
      let error = false;

      for(let i in action.response) {
        const response = action.response[i];
        if(response.success !== true) {
          error = {
            message: action.response,
            action: action.action,
          };
        } else {
          let blogToUpdate = newBlogs.find(x => x.id == response.blog_id)
          blogToUpdate.custom_contents.push({
            id: response.custom_content.id,
            source: {
              text: response.custom_content.source.text
            },
            target: {
              text: response.custom_content.target.text
            }
          });
        }
      }

      return {
        ...state,
        blogs: newBlogs,
        create_blog_custom_contents_pending: false,
        error: error
      }
    }
    case DELETE_BLOG_CUSTOM_CONTENT_PENDING: {
      return {
        ...state,
        delete_blog_custom_content_pending: true,
        error: false,
      }
    }
    case DELETE_BLOG_CUSTOM_CONTENT_PROGRESS: {
      return {
        ...state,
        progress: action.progress
      }
    }
    case DELETE_BLOG_CUSTOM_CONTENT_RESPONSE: {
      let newBlogs = state.blogs.slice()
      let error = false;

      if(action.response.success !== true) {
          error = {
            message: action.response,
            action: action.action,
          };
      } else {
        let blogToUpdate = newBlogs.find(x => x.id == action.response.blog_id)
        blogToUpdate.custom_contents = blogToUpdate.custom_contents.filter(x => x.id != action.response.id)
      }

      return {
        ...state,
        blogs: newBlogs,
        delete_blog_custom_content_pending: false,
        error: error
      }
    }
    case EXPORT_BLOGS_PENDING: {
      return {
        ...state,
        progress: 0,
        export_blogs_pending: true,
        export_po_download_url: null,
        export_csv_download_url: null,
        error: false,
      }
    }
    case EXPORT_BLOGS_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    case EXPORT_BLOGS_RESPONSE: {
      if(action.response.success == true) {
        return {
          ...state,
          progress: 100,
          export_blogs_pending: false,
          export_po_download_url: _exportDownloadLinkDecorator(action.response.po_download_url, action.options),
          export_csv_download_url: _exportDownloadLinkDecorator(action.response.csv_download_url, action.options),
        }
      } else {
        return {
          ...state,
          progress: 100,
          export_blogs_pending: false
        }
      }
    }
    case IMPORT_BLOGS_PENDING: {
      return {
        ...state,
        progress: 0,
        import_blogs_pending: true,
        import_cancelled: false,
        imported_entries: 0,
        error: false,
      }
    }
    case IMPORT_BLOGS_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    case IMPORT_BLOGS_RESPONSE: {
      // the merchant cancelled after reviewing the file, nothing was imported
      if(action.response && action.response.cancelled === true) {
        return {
          ...state,
          progress: 0,
          import_blogs_pending: false,
          import_cancelled: true
        }
      }
      let isOk = true;
      let importedEntries = 0;
      action.response.forEach(response => {
        if(response.success !== true) {
          isOk = false
        } else {
          importedEntries += response.imported_entries
        }
      })

      if(isOk == true) {
        return {
          ...state,
          progress: 100,
          import_blogs_pending: false,
          imported_entries: importedEntries
        }
      } else {
        return {
          ...state,
          progress: 100,
          import_blogs_pending: false,
          imported_entries: importedEntries,
          error: {
            message: action.response.filter(response => response.success !== true),
            action: action.action,
          }
        }
      }
    }
    case CLEAR_EXPORT_URLS: {
      return {
        ...state,
        progress: 0,
        export_blogs_pending: false,
        export_csv_download_url: null,
        export_po_download_url: null,
      }
    }
    default:
      return state
  }
}

// ACTIONS
export const resetErrors = () => {
  return dispatch => {
    dispatch({
      type: RESET_ERRORS
    });
  }
}
export const syncBlogs = (language, callback, options = {}) => {
  return dispatch => {
    // A held sync is the bulk tool's own work: it runs and answers its callback,
    // but nothing of it reaches the store
    const mirror = (action) => {
      if(options.held !== true) {
        dispatch(action);
      }
    }
    mirror({
      type: SYNC_BLOGS_PENDING
    })

    API.syncBlogs(
      language,
      progress => {
        mirror({
          type: SYNC_BLOGS_PROGRESS,
          progress: progress
        })
      },
      response => {
        // A dropped sync is not dispatched at all: the switch that dropped it has already
        // started the sync for the language now on screen, and that one owns the pending flag.
        if(response && response.aborted === true) {
          // The answer is dropped, but the callback still fires: callers use it to resolve a
          // promise, and one that never hears back leaves the ui waiting for good.
          if(callback) {
            callback(response);
          }
          return;
        }

        mirror({
          type: SYNC_BLOGS_RESPONSE,
          response: response,
          action: () => syncBlogs(language, callback)
        }
      );
      if(callback) {
        callback(response);
      }
    }, options)
  }
}

export const syncBlog = (blogId, languageId) => {  
  return dispatch => {
    dispatch({
      type: SYNC_BLOG_PENDING
    })

    API.syncBlog(
      blogId,
      languageId,
      response => {
        dispatch({
          type: SYNC_BLOG_RESPONSE,
          response: response,
          action: () => syncBlog(blogId, languageId)
        })
      }
    )
  }
}

export const saveBlogs = (language, items, force = 0) => {  
  return (dispatch, getState) => {
    dispatch({
      type: SAVE_BLOGS_PENDING
    })

    API.saveBlogs(
      language,
      items,
      force,
      progress => {
        dispatch({
          type: SAVE_BLOGS_PROGRESS,
          progress: progress
        })
      },
      response => {
        if(response && response.aborted === true) {
          dispatch({
            type: SAVE_BLOGS_ABORTED
          })
          return;
        }

        dispatch({
          type: SAVE_BLOGS_RESPONSE,
          response: response,
          items: items,
          stale: getState().shop.shop.edit_language !== language,
          action: () => saveBlogs(language, items, force)
        })
      })
  }
}

export const syncBlogMetafields = (blog, language) => {  
  return (dispatch, getState) => {
    dispatch({
      type: SYNC_BLOG_METAFIELDS_PENDING
    })

    API.syncBlogMetafields(
      blog,
      language,
      progress => {
        dispatch({
          type: SYNC_BLOG_METAFIELDS_PROGRESS,
          progress: progress
        })
      },
      response => {
        // Nothing refires a row sync after a switch, so the dropped one clears its own flag
        if(response && response.aborted === true) {
          dispatch({
            type: SYNC_BLOG_METAFIELDS_ABORTED
          })
          return;
        }

        dispatch({
          type: SYNC_BLOG_METAFIELDS_RESPONSE,
          response: response,
          stale: getState().shop.shop.edit_language !== language,
          action: () => syncBlogMetafields(blog, language)
        }
      )
    })
  }
}

export const createBlogCustomContents = (blog, language, items) => {  
  return dispatch => {
    dispatch({
      type: CREATE_BLOG_CUSTOM_CONTENTS_PENDING
    })

    API.createBlogCustomContents(
      blog,
      language,
      items,
      progress => {
        dispatch({
          type: CREATE_BLOG_CUSTOM_CONTENTS_PROGRESS,
          progress: progress
        })
      },
      response => {
        dispatch({
          type: CREATE_BLOG_CUSTOM_CONTENTS_RESPONSE,
          response: response,
          items: items,
          action: () => createBlogCustomContents(blog, language, items)
        })
      })
  }
}

export const deleteBlogCustomContent = (blog, ids) => {
  return dispatch => {
    dispatch({
      type: DELETE_BLOG_CUSTOM_CONTENT_PENDING
    })

    API.deleteBlogCustomContent(
      blog,
      ids,
      progress => {
        dispatch({
          type: DELETE_BLOG_CUSTOM_CONTENT_PROGRESS,
          progress: progress
        })
      },
      response => {
        dispatch({
          type: DELETE_BLOG_CUSTOM_CONTENT_RESPONSE,
          response: response,
          action: () => deleteBlogCustomContent(blog, ids)
        })
      })
  }
}

export const exportBlogs = (language, options) => {
  return dispatch => {
    dispatch({
      type: EXPORT_BLOGS_PENDING
    })

    API.exportBlogs(
      language, 
      options,
      progress => {
        dispatch({
          type: EXPORT_BLOGS_PROGRESS,
          progress: progress
        })
      },
      response => {
        dispatch({
          type: EXPORT_BLOGS_RESPONSE,
          response: response,
          options: options,
          action: () => exportBlogs(language, options)
        }
      )
    })
  }
}

export const importBlogs = (file, fileType, language, options) => {
  return dispatch => {
    dispatch({
      type: IMPORT_BLOGS_PENDING
    })

    API.importBlogs(
      file,
      fileType,
      language, 
      options,
      progress => {
        dispatch({
          type: IMPORT_BLOGS_PROGRESS,
          progress: progress
        })
      },
      response => {
        dispatch({
          type: IMPORT_BLOGS_RESPONSE,
          response: response,
          action: () => importBlogs(file, fileType, language, options)
        }
      )
    })
  }
}

export const clearExportUrls = () => {
  return dispatch => {
    dispatch({
      type: CLEAR_EXPORT_URLS
    });
  }
}